import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleInvitePeople, invitePeople, toggleModalFeedbackThanks, clearInviteSentStatus } from '../../../redux/main/main.actions';
import { selectIsModalInvitePeopleEnabled, selectInviteSentStatus } from '../../../redux/main/main.selectors';

import { showNotify } from '../../../redux/notify/notify.actions';

import Modal from '../Modal/Modal';
import './ModalInvitePeople.scss';

export const ModalInvitePeople = () => {
    const isOpen = useSelector(selectIsModalInvitePeopleEnabled);

    const dispatch = useDispatch();

    const inputRef = useRef(null);
    const [value, setValue] = useState('');

    const inviteSentStatus = useSelector(selectInviteSentStatus);
    const [sentCount, setSentCount] = useState(0);

    useEffect(() => {
        if (inviteSentStatus === 'success') {
            dispatch(toggleInvitePeople(null));
            dispatch(toggleModalFeedbackThanks('invite_people', 'main'));

            setTimeout(() => {
                setValue('');
                setSentCount(0);
            }, 300);

        } else if (inviteSentStatus === 'error') {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }

        return () => {
            dispatch(clearInviteSentStatus());
        };
    }, [inviteSentStatus]);


    const handleSave = () => {
        if (!value) {
            dispatch(showNotify({ message: 'Please enter email address' }));
            if (inputRef.current) {
                inputRef.current.focus();
            }
            return;
        }
        if (!validateEmail(value)) {
            dispatch(showNotify({ message: 'Email is not valid' }));
            if (inputRef.current) {
                inputRef.current.focus();
            }
            return;
        }

        if (sentCount > 4) return;

        setSentCount(sentCount + 1);
        dispatch(invitePeople(value));

        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    const handleCancel = () => {
        dispatch(toggleInvitePeople(null));
        setTimeout(() => {
            setValue('');
            setSentCount(0);
        }, 300);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSave();
        }
    };

    const handleRender = () => {
        if (isOpen && inputRef.current) {
            // inputRef.current.focus();
        }
    };

    const handleChange = (e) => {
        if (e.target.value?.length < 150) {
            setValue(e.target.value);
        }
    }

    const validateEmail = (emailValue) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(emailValue);
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-invite-people`}
            onCancel={handleCancel}
            onShouldRender={handleRender}
        >
            <div className="modal-content-header">{`Invite people`}</div>
            <div className="modal-content-body">

                <input
                    maxLength="150"
                    autoFocus={(window.innerWidth >= 1000)}
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    inputMode="text"
                    ref={inputRef}
                    placeholder="Enter email address"
                    value={value}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                />
                <button
                    disabled={sentCount > 4}
                    onClick={() => handleSave()}>Invite</button>

                {/* <div className='bottom-section'>
                    <div className='bottom-section-left'>
                        <div className='bottom-section-left-text'>
                            <span className="bottom-section-left-text-subtitle">
                                <span>Already member?</span>
                                <span className='bottom-section-left-text-link' onClick={(e) => { dispatch(toggleBtnSidebarInviteToDiagram({})); }}>Invite people to one of your diagrams.</span>
                            </span>
                        </div>
                    </div>
                </div> */}

            </div>
        </Modal>
    );
};

export default ModalInvitePeople;
